import * as yup from 'yup';

export const createContractModuleSchema = yup.object().shape({

});